import React from 'react';
import { Box, Typography } from '@mui/material';
import ShieldIcon from '@mui/icons-material/Shield';

const Logo = ({ variant = 'default' }) => {
  const isLight = variant === 'light';
  
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <ShieldIcon
          sx={{
            fontSize: 32,
            color: isLight ? 'white' : 'primary.main',
            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            bgcolor: isLight ? 'white' : 'primary.main',
            animation: 'pulse 2s infinite',
            '&::after': {
              content: '""',
              position: 'absolute',
              left: '-2px',
              top: '-2px',
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              bgcolor: isLight ? 'rgba(255,255,255,0.3)' : 'primary.light',
              animation: 'pulse 2s infinite',
            },
            '@keyframes pulse': {
              '0%': {
                transform: 'scale(1)',
                opacity: 1,
              },
              '50%': {
                transform: 'scale(1.3)',
                opacity: 0.7,
              },
              '100%': {
                transform: 'scale(1)',
                opacity: 1,
              },
            },
          }}
        />
      </Box>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          fontSize: '1.2rem',
          letterSpacing: '0.5px',
          color: isLight ? 'white' : 'text.primary',
          textShadow: isLight ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
          '& span': {
            color: isLight ? 'rgba(255,255,255,0.9)' : 'primary.main',
            fontWeight: 800,
          },
        }}
      >
        Security<span>OnDemand</span>
      </Typography>
    </Box>
  );
};

export default Logo; 